import React from 'react';
import {
  IStackProps,
  SearchInput,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { useDataTableSearch } from 'src/components/DataTable/components/DataTableSearch/hooks/useDataTableSearch';

export type DataTableSearchProps = {
  placeholder?: string;
} & Pick<IStackProps, 'x' | 'y'>;

export function DataTableSearch({
  placeholder,
  x = 'none',
  y = 'none',
}: DataTableSearchProps): JSX.Element {
  const { query, setQuery, submit } = useDataTableSearch();

  return (
    <Stack x={x} y={y} minWidth="350px">
      <SearchInput
        width="100%"
        label=""
        aria-label="Search"
        variant="primary"
        placeholder={placeholder}
        value={query}
        onChange={(value): void => setQuery(value)}
        onSubmit={(): void => submit(query.trim())}
      />
    </Stack>
  );
}
